import React from 'react';
import styled from 'styled-components';

const ContentLayout = styled.div`
  width: ${(props) => ((props.isSigningStep || props.isOnboardingV2) ? '100%' : '310px')};
`;
const DisplayLayout = styled.div`
  display: ${(props) => (props.isSigningStep ? 'block' : 'flex')};
  justify-content: center;
`;

export default function StateTaxFormLayout(props) {
  const { isSigningStep = false, children, isOnboardingV2 } = props;

  return (
    <DisplayLayout isSigningStep={isSigningStep}>
      <ContentLayout
        isSigningStep={isSigningStep}
        isOnboardingV2={isOnboardingV2}
      >
        {children}
      </ContentLayout>
    </DisplayLayout>
  );
}
